import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Build stamp, exposed for cache-busting and support diagnostics.
(window as any).__BITZO_BUILD__ = "2026-07-06T2";
